import type { QueryClient } from '@tanstack/svelte-query';
import {
	getSeriesBaseParams,
	getSeriesRestParams,
} from '../getSeriesRestParams/getSeriesRestParams';
import {
	editionsGalleryItemsQueryKey,
	getEditionsGalleryItems,
} from '#lib/websites/editions/api/getEditionsGalleryPage.js';
import { SERIES_GALLERY_STALE_TIME } from '#lib/websites/editions/constants/gallery.js';
import type { SeriesPageLoadEvent } from '$routes/editions/series/[slug]/types';

export const seriesPageLoad = async ({
	parent,
	data,
	url,
	params,
	fetch,
}: SeriesPageLoadEvent) => {
	const parentData = await parent();
	const queryClient: QueryClient = parentData.queryClient;
	const slug = params.slug;

	queryClient.setQueryData(
		editionsGalleryItemsQueryKey(getSeriesBaseParams(slug)),
		{ pageParams: [0], pages: [data.editions] }
	);

	const restParams = getSeriesRestParams({
		slug,
		searchParams: url.searchParams,
		filterSections: data.filterSections,
	});

	queryClient.prefetchInfiniteQuery({
		queryKey: editionsGalleryItemsQueryKey(restParams),
		queryFn: ({ pageParam }) =>
			getEditionsGalleryItems(fetch, {
				...restParams,
				offset: pageParam as number,
			}),
		initialPageParam: 0,
		staleTime: SERIES_GALLERY_STALE_TIME,
	});

	return {
		...parentData,
		...data,
		params: restParams,
	};
};
